import { render } from "./RegistrarReportsDialog.vue?vue&type=template&id=be907b5e&scoped=true"
import script from "./RegistrarReportsDialog.vue?vue&type=script&lang=js"
export * from "./RegistrarReportsDialog.vue?vue&type=script&lang=js"

import "./RegistrarReportsDialog.vue?vue&type=style&index=0&id=be907b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be907b5e"]])

export default __exports__